import React from 'react'
import { connect } from 'react-redux'
import * as propTypes from 'prop-types'
import {
  closePopup,
  getBarcodes,
  selectSort,
  setCarrier,
  setPage,
  setRowsPerPage,
  setTrackingNumber,
  clearTrackingInfo,
  setVisibility,
  showPopup,
  submitShipment,
  updateShipmentSummary,
} from '../../store/shipmentBarcode/actionCreator'
import { carriers } from '../../util/ShippingCarriers'
import { setHeaderTitleArray } from '../../store/layout/actionCreator'
import TabbedPopUp from '../../components/PopUp/TabbedPopUp'
import { makeTabTables, getTCINAsTitle } from '../../util/Table'
import { dataTabLabelsShippedVendor } from '../../enums/tableTabs'
import CustomCanvasTable from 'components/CanvasTable/CustomCanvasTable'
import {
  Input,
  Caption,
  Heading,
  Grid,
  Card,
} from '@enterprise-ui/canvas-ui-react'

export class ShipmentBarcodePage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      carrier: '',
      text: '',
      provideDetailsLater: false,
      printButton: false,
      isVisibleOtherCarrier: false,
      newCarrier: '',
    }
  }

  componentDidMount() {
    const { setHeaderTitleArray } = this.props
    setHeaderTitleArray([{ title: 'Shipment Barcode' }])
  }

  disableButton = () => {
    /**
     * Process Shipment Button should be enabled only if the following critera is met:
     * 1. printButton must always be triggered
     * 2. either tracking number and carrier are supplied or provideDetailsLater is checked
     *
     * returns true if button should be disabled, false otherwise
     */

    // returns boolean on true, if all tracking information fields are populated
    let hasTrackingInfo = this.props.data.flatMap(
      (shipping) => !!shipping.trackingNumber && !!shipping.carrier && true
    )
    // ensure that either tracking info is fully provided or flag to defer information is selected [XOR operation used]
    let shipmentInfoUndefined = !hasTrackingInfo[0]
      ? !this.state.provideDetailsLater
      : !!this.state.provideDetailsLater

    return shipmentInfoUndefined || !this.state.printButton
  }

  disableShippingTextFields = () => {
    return this.state.provideDetailsLater
  }

  handleTrackingNumberChange(trackingNumber, shipmentNumber) {
    const { onTrackingNumberChange } = this.props
    const trackingNumVal = trackingNumber.target.value
    this.setState((state) => ({
      ...state,
      text: trackingNumVal,
    }))
    onTrackingNumberChange({
      trackingNumber: trackingNumber.target.value,
      shipmentNumber: shipmentNumber,
    })
  }

  handleCarrierChange = (carrier, shipmentNumber, carrierType = '') => {
    const { onCarrierChange = () => {} } = this.props
    if (carrierType === 'new') {
      this.setState((state) => ({
        ...state,
        newCarrier: carrier,
      }))
    } else {
      this.setState((state) => ({
        ...state,
        carrier: carrier,
        newCarrier: '',
        isVisibleOtherCarrier: false,
      }))
    }
    onCarrierChange({
      carrier: carrier,
      shipmentNumber: shipmentNumber,
    })
  }

  handleTextbox(carrier, shipmentNumber) {
    const carrierVal = carrier
    if (carrierVal === 'OTHER') {
      this.setState((state) => ({
        ...state,
        isVisibleOtherCarrier: true,
        carrier: 'OTHER',
      }))
    } else {
      this.handleCarrierChange(carrierVal, shipmentNumber)
    }
  }

  handleGenerateBarcode = () => {
    this.props.getBarcodes(this.props.data, (barcodes) => {
      const file = new Blob([barcodes], { type: 'application/pdf' })
      let fileURL
      if (window.navigator.msSaveOrOpenBlob) {
        fileURL = window.navigator.msSaveOrOpenBlob(file, 'barcodeLabel.pdf')
      } else {
        fileURL = URL.createObjectURL(file)
        window.open(fileURL).print()
      }
    })

    this.setState((state) => ({
      ...state,
      printButton: true,
    }))
  }

  handleCheckBoxChange = () => {
    const { clearTrackingInfo, parentCallback = () => {} } = this.props
    const { provideDetailsLater } = this.state
    this.setState((state) => ({
      ...state,
      carrier: '',
      text: '',
      newCarrier: '',
      provideDetailsLater: !state.provideDetailsLater,
      isVisibleOtherCarrier: false,
    }))
    parentCallback(!provideDetailsLater)
    clearTrackingInfo()
  }

  handleProcessShipment = (event) => {
    const { data, processShipment } = this.props
    processShipment(data)
  }

  render() {
    const {
      classes = {},
      closePopup,
      columnData,
      data,
      onClick,
      onSortSelectedChange,
      order,
      orderBy,
      page,
      popUpIsVisible,
      popUpItem = {},
      rowsPerPage,
      setPage,
      setRowsPerPage,
      shipmentDestination = '',
      shipmentNumber,
      showPopup,
    } = this.props

    const {
      provideDetailsLater,
      carrier = '',
      text = '',
      newCarrier = '',
      isVisibleOtherCarrier = false,
    } = this.state

    const dataFieldKeys = columnData.map((column) => column.id)
    return (
      <Grid.Container>
        <Grid.Item xs={12}>
          <Grid.Container>
            <Grid.Item xs={4}>
              <Card elevation={0} corners="all">
                <Grid.Container
                  style={{
                    padding: '15px',
                    height: '288px',
                  }}
                  direction={'column'}
                >
                  <Grid.Item>
                    <Heading
                      style={{
                        fontWeight: 500,
                        fontSize: '20px',
                        marginBottom: '7px',
                      }}
                    >
                      Shipping Address
                    </Heading>
                  </Grid.Item>
                  <Grid.Item>
                    {shipmentDestination.split(',').map((line) => (
                      <div style={{ textIndent: '20px' }}>{line}</div>
                    ))}
                  </Grid.Item>
                </Grid.Container>
              </Card>
            </Grid.Item>
            <Grid.Item xs={8}>
              <Card elevation={0} corners="all">
                <Grid.Container style={{ padding: '15px' }}>
                  <Grid.Item item xs={12}>
                    <Grid.Container container justify={'space-between'}>
                      <Grid.Item item>
                        <Heading
                          style={{
                            fontWeight: 500,
                            fontSize: '20px',
                            marginBottom: '7px',
                          }}
                        >
                          {' '}
                          Add Shipping Details (Optional)
                        </Heading>

                        <Caption
                          style={{ fontSize: '12px', marginBottom: '5px' }}
                        >
                          You will have the opportunity to provide this
                          information later
                        </Caption>
                      </Grid.Item>
                      <Grid.Item item>
                        <Input.Checkbox
                          checked={provideDetailsLater}
                          label="Provide Shipping Details Later"
                          onChange={() => this.handleCheckBoxChange()}
                        />
                      </Grid.Item>
                    </Grid.Container>
                  </Grid.Item>
                  <Grid.Item item xs={12}>
                    <div>
                      <Input.Label
                        style={{ fontSize: '15px', fontWeight: 500 }}
                        for="carrier-select"
                      >
                        Select Carrier
                      </Input.Label>
                      <Input.Select
                        id="carrier-select"
                        style={{ height: '50px' }}
                        disabled={this.disableShippingTextFields()}
                        onUpdate={(id, value) =>
                          this.handleTextbox(value, shipmentNumber)
                        }
                        options={carriers.map((dat) => ({
                          value: dat.value,
                          label: dat.value,
                        }))}
                        value={carrier}
                      />
                    </div>
                  </Grid.Item>
                  <Grid.Item item xs={12}>
                    {isVisibleOtherCarrier ? (
                      <div>
                        <Input.Label
                          style={{ fontSize: '15px', fontWeight: 500 }}
                          for="other-carrier"
                        >
                          Enter Other Carrier
                        </Input.Label>
                        <Input.Text
                          id="other-carrier"
                          style={{ height: '50px', width: '100%' }}
                          disabled={this.disableShippingTextFields()}
                          onChange={(event) => {
                            const carrierValue = event.target.value
                            this.handleCarrierChange(
                              carrierValue,
                              shipmentNumber,
                              'new'
                            )
                          }}
                          value={newCarrier}
                        />
                      </div>
                    ) : (
                      ''
                    )}
                  </Grid.Item>
                  <Grid.Item xs={12}>
                    <div>
                      <Input.Label
                        style={{ fontSize: '15px', fontWeight: 500 }}
                        for="trackingNumber"
                      >
                        Tracking Number
                      </Input.Label>
                      <Input.Text
                        id="trackingNumber"
                        style={{ height: '50px', width: '100%' }}
                        disabled={this.disableShippingTextFields()}
                        onChange={(event) => {
                          this.handleTrackingNumberChange(event, shipmentNumber)
                        }}
                        value={text}
                      />
                    </div>
                  </Grid.Item>
                </Grid.Container>
              </Card>
            </Grid.Item>
          </Grid.Container>
        </Grid.Item>
        <Grid.Item xs={12}>
          <CustomCanvasTable
            columnData={columnData}
            clickableColumn={columnData.map((col) => col.id)}
            onSortSelectedChange={onSortSelectedChange}
            data={data}
            currentPage={page}
            rowsPerPage={rowsPerPage}
            totalRowsCount={data.length || Number(0)}
            showPopup={(data) => showPopup(data)}
            onRequestPage={setPage}
            onPageSizeChange={setRowsPerPage}
            sortable={true}
            paginationlocation="top-bottom"
          />
        </Grid.Item>
        <TabbedPopUp
          dataTabLabels={dataTabLabelsShippedVendor}
          isVisible={popUpIsVisible}
          data={makeTabTables(popUpItem, classes, dataTabLabelsShippedVendor)}
          onClose={closePopup}
          title={getTCINAsTitle(popUpItem)}
          fullWidth={true}
        />
      </Grid.Container>
    )
  }
}

function mapStateToProps(state) {
  return {
    barcodes: state.shipmentBarcode.shipmentBarcodeRequestFileStream,
    columnData: state.shipmentBarcode.stepOneColumnData,
    data: state.shipmentBarcode.data,
    onClick: state.shipmentBarcode.onClick,
    order: state.shipmentBarcode.order,
    orderBy: state.shipmentBarcode.orderBy,
    page: state.shipmentBarcode.page,
    popUpIsVisible: state.shipmentBarcode.popUpIsVisible,
    popUpItem: state.shipmentBarcode.popUpItem,
    rowCount: state.shipmentBarcode.rowCount,
    rowsPerPage: state.shipmentBarcode.rowsPerPage,
    shipmentDestination: state.shipmentBarcode.shipmentDestination,
    shipmentNumber: state.shipmentBarcode.shipmentNumber,
    visible: state.shipmentBarcode.visible,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    closePopup: () => dispatch(closePopup()),
    getBarcodes: (samples, showBarcodesCallback) =>
      dispatch(getBarcodes(samples, showBarcodesCallback)),
    onCarrierChange: (event) => dispatch(setCarrier(event)),
    onSortSelectedChange: (orderBy, order) =>
      dispatch(selectSort(orderBy, order)),
    onTrackingNumberChange: (event) => dispatch(setTrackingNumber(event)),
    clearTrackingInfo: () => dispatch(clearTrackingInfo()),
    onVisibliltyChange: (event) => dispatch(setVisibility(event)),
    processShipment: (data) => dispatch(submitShipment(data)),
    setPage: (page) => dispatch(setPage(page)),
    setRowsPerPage: (rowsPerPage) => dispatch(setRowsPerPage(rowsPerPage)),
    showPopup: (item) => dispatch(showPopup(item)),
    updateOrderSummary: (orderNum, status) =>
      dispatch(updateShipmentSummary(orderNum, status)),
    setHeaderTitleArray: (headerTitleArray) =>
      dispatch(setHeaderTitleArray(headerTitleArray)),
  }
}

ShipmentBarcodePage.propTypes = {
  data: propTypes.array,
  onSortSelectedChange: propTypes.func,
  page: propTypes.number,
  rowsPerPage: propTypes.number,
}

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentBarcodePage)
